import { render, staticRenderFns } from "./DetailTicketing.html?vue&type=template&id=1d10a16f&"
import script from "./DetailTicketing.js?vue&type=script&lang=js&"
export * from "./DetailTicketing.js?vue&type=script&lang=js&"
import style0 from "./DetailTicketing.scss?vue&type=style&index=0&lang=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports